import styled from "styled-components";

export const Wrapper = styled.div`
  display: block;
  opacity: ${p => (p.show ? 1 : 0)};
  position: fixed;
  -webkit-transition: opacity 600ms, visibility 600ms;
  transition: opacity 600ms, visibility 600ms;
  width: 100%;
  z-index: 2;
  top: 60px;

  &&& {
    background: transparent;
  }
`;
